/**
 * Staging/dev invite-only access — mirrors Firestore rules + analytics-server checks.
 * Prod builds omit REACT_APP_APP_ENV and never hit this path.
 */

export function getAppEnvLabel() {
  return process.env.REACT_APP_APP_ENV || '';
}

export function isInviteOnlyBuild() {
  const env = getAppEnvLabel();
  return env === 'staging' || env === 'development';
}

/** @deprecated prefer isInviteOnlyBuild — kept for staging-specific call sites */
export function isStagingBuild() {
  return getAppEnvLabel() === 'staging';
}

export function isDevBuild() {
  return getAppEnvLabel() === 'development';
}

/**
 * @param {string | null | undefined} email
 * @param {{ accessMode?: string, allowedEmails?: string[], allowedEmailDomainPattern?: string } | null | undefined} config
 */
export function emailMatchesStagingAllowlist(email, config) {
  if (!config || config.accessMode !== 'allowlist') return true;
  if (!email || typeof email !== 'string') return false;

  const normalized = email.trim().toLowerCase();
  const allowedEmails = (config.allowedEmails || []).map((e) => String(e).trim().toLowerCase());
  if (allowedEmails.includes(normalized)) return true;

  const pattern = (config.allowedEmailDomainPattern || '').trim();
  if (!pattern) return false;

  try {
    return new RegExp(pattern, 'i').test(normalized);
  } catch {
    return false;
  }
}
